<div class="row">
  <!-- files input -->
  <div class="col-lg-6 mb-2">
    <ngx-file-drop dropZoneLabel="Drop files here"
      dropZoneClassName="container-fluid border rounded bg-syk-grey p-0 h-100"
      contentClassName="d-flex align-items-center justify-content-center h-100" (onFileDrop)="dropped($event)"
      [accept]="accept()" [disabled]="disabled()">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <button type="button" class="btn m-0 p-0 h-100 w-100 d-flex align-items-center justify-content-center"
          (click)="!disabled() && openFileSelector()" [attr.disabled]="disabled() ? true: null">
          <div class="text-center m-4">
            <i class="bi bi-cloud-arrow-up-fill fs-1"></i>
            <p class="fs-5 fw-semibold m-0">
              Drag and drop a file
            </p>
            <p class="fs-6 m-0">
              or click to choose from your device
            </p>
          </div>
        </button>
      </ng-template>
    </ngx-file-drop>
  </div>
  <!-- files list -->
  @if (files().length > 0) {
    <div class="col-lg-6 mb-2">
      <ul class="list-group">
        @for (file of files(); track file) {
          <li class="container list-group-item">
            <div class="row align-items-center">
              <div class="col-auto px-1">
                @if (isValid(file.file)) {
                  <i class="bi bi-check-circle-fill text-success"></i>
                } @else {
                  <i class="bi bi-x-circle-fill text-danger"></i>
                }
              </div>
              <div class="col px-1 text-truncate">
                {{file.file.name}}
              </div>
              <div class="col-auto">
                {{file.file.size | filesize}}
              </div>
              @if (!disabled()) {
                <button type="button" class="btn col-auto m-0 mx-1 p-0" (click)="remove($index)">
                  <i class="bi bi-trash-fill"></i>
                </button>
              }
            </div>
          </li>
        }
      </ul>
    </div>
  }
</div>
